import React from "react";
import { Box, Button, Card, ThemeProvider, Typography } from "@mui/material";
import theme from "../../assets/theme/theme";
import RefreshIcon from "@mui/icons-material/Refresh";
import { GLOBALMESSAGES } from "../../constants/messages";
import { isNetworkFailure } from "../../utils/userFacingError";

interface IProps {
    error?: Error;
    resetErrorBoundary?: () => void;
}

export function ErrorFallBackUI(props: IProps){
    // Bug 75680: a crash caused by the connection dropping has to read as a connection
    // problem, not as an app fault the user should report to an administrator.
    const isNetworkDown = isNetworkFailure(props.error);

    return (
        <ThemeProvider theme={theme}>
          <>
            <div className="error-page p-4">
              <div className="text-center mb-4">
                <img
                  src="/logo-transparent.svg"
                  alt="logo"
                  className="signin-logo"
                />
              </div>
              <Card variant="outlined" className="card p-4 text-center">
                 <Typography variant="h5" className="error-sub-title">
                 {isNetworkDown
                    ? GLOBALMESSAGES.NETWORK_ERROR_TITLE
                    : "Something went wrong, Please try refreshing the page."}
                            </Typography>
                
                            {/* Bug 79203: never render props.error.message — it put raw text like
                                "s.forEach is not a function" in front of the user. ErrorBoundary
                                has already logged the real message and component stack to
                                Portal_ErrorLog. Same wording as ErrorFallBackUIRoute. */}
                            <Typography variant="body1" className="page-error-text">
                            {isNetworkDown ? GLOBALMESSAGES.NETWORK_ERROR : GLOBALMESSAGES.GLOBAL_ERROR}
                            </Typography>
                
                <div className="text-center">
                  <Box sx={{}} className="action-container">
                    <Button variant="contained" onClick={props.resetErrorBoundary} startIcon={<RefreshIcon />}>
                      Try again
                    </Button>
                  </Box>
                </div>
              </Card>
            </div>
          </>
        </ThemeProvider>
      );
    }
    
